import ReviewsComponent from './ReviewsComponent';

export default ReviewsComponent;
